import React from "react";
import styled from "styled-components";
import RedifiningPLM from "../../../assets/images/solutions/RedifiningPLM.jpg";

const RedifiningPLMSolutionOverview = () => {
  return (
    <AboutSectionWrapper>
      <Container className="container">
        <Row>
          {/* Content Column */}
          <ContentColumn>
            <InnerColumn>
              <SecTitle>
                <Title>About Us</Title>
                <Heading>Overview</Heading>
              </SecTitle>
              <Text>
                NexTech plm Solutions address challenges cost-effectively
                through unique methodology to achieve best alignment of
                Teamcenter Infrastructure, Performance, and Teamcenter Solutions
                to ensure right value addition to business. Redefining PLM
                system is becoming a necessity for most of the customer to
                ensure the PLM system is up-to-date and in right alignment with
                Teamcenter Infrastructure, Performance and Solutions to extract
                optimum values from the PLM system while addressing below
                challenges.
              </Text>
              <OrderedList>
                <OrderedListItem>
                  Data, Application Integration, and User growth
                </OrderedListItem>
                <OrderedListItem>
                  Architecture Changes, New and Enhanced functionality by
                  upcoming Teamcenter Releases
                </OrderedListItem>
                <OrderedListItem>
                  Capability mapping for new business requirements in Teamcenter
                </OrderedListItem>
                <OrderedListItem>Existing issues like</OrderedListItem>
                {/* More list items */}

                <UnorderedList>
                  <ListItem>
                    Lack of critical content in existing solution design
                  </ListItem>
                  <ListItem>
                    Queries and Data loading in tools like MCAD taking too long
                  </ListItem>
                  <ListItem>
                    Rich client performance degradation due to data growth,
                    increased users, new integration, Teamcenter upgrade, etc.
                  </ListItem>
                  <ListItem>
                    The Teamcenter process keeps going down, connections are
                    constantly being lost
                  </ListItem>
                  <ListItem>Workflow gets hang frequently</ListItem>
                  <ListItem>
                    Uncontrolled storage growth for metadata and volume data
                  </ListItem>
                  <ListItem>
                    Weak performance tuning, scalability concerns
                  </ListItem>
                  <ListItem>
                    Poor Teamcenter System usage, configuration, and development
                    documentation.
                  </ListItem>
                  <ListItem>
                    Redefine coordination between system administration,
                    networking, storage, and application support teams
                  </ListItem>
                  <ListItem>
                    Redefining monitoring and tuning of applications to ensure
                    reliability and performance.
                  </ListItem>
                </UnorderedList>
              </OrderedList>
            </InnerColumn>
          </ContentColumn>
          {/* Image Column */}
          <ImageColumn>
            <ImageInnerColumn data-wow-delay="0ms" data-wow-duration="1500ms">
              <ImageWrapper>
                <Image
                  src={RedifiningPLM}
                  alt="Redifining PLM"
                />
                <ImageOverlayBox></ImageOverlayBox>
              </ImageWrapper>
            </ImageInnerColumn>
          </ImageColumn>
        </Row>
      </Container>
    </AboutSectionWrapper>
  );
};

export default RedifiningPLMSolutionOverview;

const AboutSectionWrapper = styled.section`
  font-family: "Poppins", system-ui;
  position: relative;
  padding: 20px 0px;
`;

const Container = styled.div`
  .container;
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const ContentColumn = styled.div`
  flex: 1;
  position: relative;
  margin-bottom: 10px;
  @media (max-width: 992px) {
    padding-right: 0;
  }
`;

const InnerColumn = styled.div`
  position: relative;
  padding-top: 50px;
`;

const SecTitle = styled.div`
  position: relative;
  padding-bottom: 40px;
`;

const Title = styled.div`
  position: relative;
  color: #d7a449;
  font-size: 18px;
  font-weight: 700;
  padding-right: 50px;
  margin-bottom: 15px;
  display: inline-block;
  text-transform: capitalize;

  &:before {
    position: absolute;
    content: "";
    right: 0px;
    bottom: 7px;
    width: 40px;
    height: 1px;
    background-color: #bbbbbb;
  }
`;

const Heading = styled.h2`
  color: #252525;
`;

const Text = styled.div`
  position: relative;
  color: #777777;
  font-size: 1em;
  line-height: 2em;
  margin-bottom: 40px;
  text-align: justify;
`;

const ImageColumn = styled.div`
  flex: 1;
  position: relative;
  margin-bottom: 50px;
`;

const ImageInnerColumn = styled.div`
  position: relative;
  padding: 40px 40px 0px 0px;
  margin-left: 50px;

  &:after {
    position: absolute;
    content: "";
    right: 27px;
    top: 5px;
    left: 40px;
    bottom: 64px;
    z-index: -1;
    border: 2px solid #d7a449;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
`;

const ImageOverlayBox = styled.div`
  position: absolute;
  left: 40px;
  bottom: 48px;
`;

const Image = styled.img`
  position: relative;
  width: 90%; /* Adjust the width as needed */
  display: block;
  margin: 0 auto; /* Center the image */
`;

const ListItem = styled.li`
  position: relative;
  color: #777777;
  font-size: 1em;
  line-height: 2em;
  margin-bottom: 10px;
  padding-left: 20px;
  text-align: justify;

  &:before {
    content: "•"; /* This is for unordered list items */
    position: absolute;
    left: 0;
    color: #d7a449;
  }
`;

const UnorderedList = styled.ul`
  list-style: none;
  padding-left: 20px;
  margin-bottom: 20px;
`;

const OrderedList = styled.ol`
  list-style-type: decimal; /* Use decimal to display numbers */
  padding-left: 20px; /* Add padding to align with your layout */
  margin-bottom: 20px;
`;

const OrderedListItem = styled.li`
  color: #777777;
  font-size: 1em;
  line-height: 2em;
  margin-bottom: 10px;
  padding-left: 10px; /* Adjusted padding to make space for numbers */
  text-align: justify;
`;
